import {
    getAdultNames, getAdultTitles, getChildNameFromCommsPlan,
    getCommunicationsPlanDetails, getFormTableColumnForDisplay, getFormTableColumnsForDisplay, getTableColumnStyles,
    mapDataFieldsForFormFields, mapDataFieldsForPDF
} from "root/DataFunctions/CommunicationsPlanDataFns";
import {getDataFromResponse} from "root/DataFunctions/BaseDataFns";
import {naturalScriptBoldFont} from "root/pdf/fonts/naturalScriptBoldFont";
import {addPage} from "root/pdf/pdf";
import {
    outputAdopterPlanDetails,
    outputAgencyDetails, outputBirthRelativePlanDetails,
    outputChildDetails
} from "root/PDFContactPlan/ContactPlanLeedsCommon";

const pdf = require ( '../pdf/pdf.js' );

export const runContactPlanLeeds = ( user_id, communications_plan_id ) =>
{
    getCommunicationsPlanDetails( user_id, communications_plan_id, true, ( response ) =>
    {
        const data = getDataFromResponse(response)[0];

        runReport( data );
    } );
}

const loadImage = (url, width, height) =>
{
    return new Promise((resolve, reject) =>
    {
        let img = new Image();

        img.addEventListener('load', e =>
        {

            let canvas = document.createElement('canvas');
            canvas.width = width; // or 'width' if you want a special/scaled size
            canvas.height = height; // or 'height' if you want a special/scaled size
            canvas.getContext('2d').drawImage(img, 0, 0, img.naturalWidth, img.naturalHeight, 0, 0, width, height);
            let dataURL = canvas.toDataURL();
            let res = canvas.toDataURL('image/png');
            let t = res.replace(/^data:image\/(png|jpg);base64,/, '');

            resolve({image: res, height: img.naturalHeight, width: img.naturalWidth});
        });

        img.addEventListener('error', () =>
        {
            reject(new Error(`Failed to load image's URL: ${url}`));
        });

        img.src = url;
    });
}

const outputAddress = (contact_plan) =>
{
    const user_name = contact_plan.firstname + ' ' + contact_plan.surname;
    const postcode = contact_plan.postcode;
    const address1 = contact_plan.address1 ;
    const address2 = contact_plan.address2 ;
    const address3 = contact_plan.address3;
    const town = 'Northumberland';

    const headers = [{ user_name: '' , address1: '', address2: '', address3: '', town: '', postcode: ''}];

    const columnStyles = { user_name: { cellWidth: 285} };

    const data = [
        [user_name,  'Your Reference: ' + '1098PGH220'],
        [address1, 'Date of issue: ' + '22nd March 2022'],
        [address2 ,  'Contact us on: (01670) 87654'],
        [address3, 'Email: arcadoption.username@sunderland.org'],
        [town, '' ],
        [postcode, '' ],
    ];

    pdf.outputTable ( headers, data,{ columnStyles: columnStyles, theme: 'plain', showHead: false, fontSize: 9, cellPadding: 2 });
}
const outputCommunication = ( contact_plan ) =>
{
    const post = 'Post to Life Story';
    const message = 'Message';
    const send = 'Send';
    const cards_and_gifts = 'Cards and Gifts';
    const face_to_face = 'Face to Face Meetings';
    const video = 'Video Meetings';
    const spaceBetween = '';

    const headers = [{ post: 'Post to Life Story' , content: 'this is the content'}];

    const columnStyles = { post: { cellWidth: 90, fontStyle: 'bold', fontName: 'naturalscriptbold'}, content: { cellWidth: 390} };

    let data = [] ;

    let items = contact_plan.items ;

    for ( let i = 0; i < items.length ; i++ )
    {
        const curItem = items[i] ;

        pdf.outputHeader(curItem.plan_section_title, '#592175', 14);

        const para = items[i].questions[0] ;

        pdf.outputHeader(para.heading, '#592175', 10);
        pdf.outputParagraph(para.response_text, {fontSize: 8});
    }

    const d = [
        [send,  'You agree to send a one way update letter once a year in June'],
        [spaceBetween, ''],
        [post,  'You can post to Life Story. Posts will be approved before sending to Archie. Posts may be held back until a more appropriate time in Archies life if they are deemed unsuitable.'],
        [spaceBetween, ''],
        [message, 'You can send a short message once a month on a Sunday. This message will be passed for approval before sending on to Archie. If the message is not approved we will let you know.'],
        [spaceBetween, ''],
        [cards_and_gifts ,  'You can send a birthday card in September and a Christmas card in December. You may not send gifts, photographs  or money with these cards.'],
        [spaceBetween, ''],
        [face_to_face, 'A face to face meeting every two weeks on Thursdays for one hour. The meeting will take place at The Childrens Center, High Street, Northumberland, at 4:30pm. If you cannot attend you must let your adoption worker know with as much notice as possible, to avoid any disappointments. Face to face meetings will be fully supervised throughout the session.'],
        [spaceBetween, ''],
        [video, 'You can video once a month. The video meeting will take place at 5pm once a month on Saturday. If you cannot attend you must let your adoption worker know with as much notice as possible, to avoid any disappointments. Video meetings will be fully supervised throughout the session.'],
    ];

    pdf.outputTable ( headers, data,{ columnStyles: columnStyles, theme: 'plain', showHead: false, fontSize: 9, cellPadding: 2 });
}

const boilerplate2 = 'It is agreed, to safeguard the child’s security, any photographs exchanged will not be uploaded to social media sites.';
const boilerplate3 = 'It is agreed that all parties to this agreement will confirm their address and contact details with the Letterbox Service a month before their exchange is due and advise of any address/ contact detail changes throughout the year. Letters will only be sent on if the address has been confirmed.';
const boilerplate4 = 'The Letterbox Team will not read letters you or the adopters send unless there are specific reasons to do so.';
const boilerplate5 = 'This agreement will cease in the year when the child/young person or the youngest party to the arrangement reaches the age of 18. Consideration can be given to extending this to 21 in individual circumstances.';
const boilerplate6 = 'Should the circumstances and needs of any party change at any time, a review of the agreement may be requested.';
const boilerplate1 = 'The adoptive parents will share the information from the birth relative in a way which is appropriate to the above child’s/young person’s needs.';

const outputHeader = async () =>
{
    const imageWidth = pdf.getDocWidth() * .3;

    const img = await loadImage('/images/logos/arc-logo.png', 500, 220);
    pdf.insertAllAboutMeImage(img.image, imageWidth, imageWidth / 2, true);
}

const outputSignature = () =>
{
    const user_signature1 = 'Amy Dodds'
    const user_signature2 = 'Steen Dodds'
    const user_signature4 = 'John Downy'

    const headers = [{signature: 'signature', user_signature: 'user signature', date: 'Dated', date_today:'28/07/2023'}];

    const width = pdf.getPrintWidth() ;

    const c1 = width * .30 ;
    const c2 = width * .60 ;
    const c3 = width * .5 ;
    const c4 = width * .5 ;

    const columnStyles = {signature: {cellWidth: c1, fontSize: 11, fontName: 'helvetica',}, user_signature: {cellWidth: c2, fontSize: 11, fontName: 'helvetica'}, date: {fontSize: 11, fontName: 'helvetica'}, date_today: { fontSize: 11, fontName: 'helvetica',} };

    const data = [
        ['Signature of Adopter:', user_signature1, 'Dated:', '24/03/2022'],
        ['Signature of Adopter:', user_signature2, 'Dated:', '24/03/2022'],
        ['Signature of Social Worker:', user_signature4, 'Dated:', '24/03/2022'],
    ];

    pdf.outputTable ( headers, data,{ columnStyles: {columnStyles}, theme: 'striped', showHead: true, fontSize: 11, fontName: 'helvetica', cellPadding: 5 });
}

const outputTerminology = (formFields) =>
{
    const terminology = formFields.terminology.response

    pdf.outputParagraph(terminology, {fontSize: 11, fontStyle: 'italic', paragraphSpacing: 0});
}

async function runReport ( contact_plan )
{
    const titleColor = '#1f7cee' ;

    const requiredFonts = [
        { filename: 'naturalscriptbold-bold.ttf', fontName: 'naturalscriptbold', style: 'bold', base64Font: naturalScriptBoldFont },
    ];

    pdf.initialise ( { additionalFonts: requiredFonts, lineHeightFactor: 1.4, margins: { topMargin: 30 } } ) ;

    // Create a list of named form field elements to store the entered data
    const formFields = mapDataFieldsForPDF ( contact_plan.items ) ;

    await outputHeader() ;

    pdf.lineFeed(1);

    pdf.outputStyledText("Letterbox Contact Agreement Form", { color: '#592175', fontSize:14, align: 'center'} );
    pdf.outputStyledText("( Birth Relatives )", { color: '#592175', fontSize:14, align: 'center'} );
    pdf.lineFeed(1);

    pdf.outputParagraph("This agreement sets out the plans for indirect contact between the above child, after they are adopted, and birth relatives, as detailed below.  Though this is not a legally binding agreement it reflects current understanding of the present and future contact needs of the above child.", { fontSize: 12 }) ;
    pdf.outputLine({fillColor: '#053064', width: .5});
    pdf.lineFeed(1);
    pdf.outputStyledText("Details of Parties Involved", { color: titleColor, fontSize:12, align: 'left'} );

    outputChildDetails( pdf, contact_plan, formFields );
    pdf.lineFeed(1);

    pdf.outputStyledText("Professional Involvement", { color: titleColor, fontSize:12, align: 'left'} );
    outputAgencyDetails ( pdf, contact_plan, formFields ) ;

    addPage();
    pdf.outputStyledText("Communication from Child / Adopters to Birth Relatives", { color: titleColor, fontSize:12, align: 'left'} );
    outputAdopterPlanDetails ( pdf, contact_plan, formFields ) ;

    pdf.outputStyledText("Communication from Birth Relatives to Child / Adopters", { color: titleColor, fontSize:12, align: 'left'} );
    outputBirthRelativePlanDetails ( pdf, contact_plan, formFields ) ;

    // pdf.outputStyledText("Agreed Indirect Contact items", { color: titleColor, fontSize:12, align: 'left'} );
    // pdf.outputLine({fillColor: '#053064', width: .5});

    pdf.outputStyledText("Terminology", {color: titleColor, fontSize: 12, align: 'left'});
    pdf.outputParagraph('It is agreed that we will use the following terminology when referring to ourselves and signing off.', {fontSize: 11, fontWeight: 'bold'});
    outputTerminology(formFields);

    addPage();

    pdf.outputLine({fillColor: '#053064', width: .5});
    pdf.outputParagraph('Terms and Conditions', {fontSize: 12, fontWeight: 'bold', color: '#053064', paragraphSpacing: 0});
    pdf.lineFeed(1);
    pdf.outputParagraph(boilerplate1, {fontSize: 11 });
    pdf.outputBulletedParagraph(boilerplate2, {bulletShape: 'circle', fontSize: 11}, 1);
    pdf.outputBulletedParagraph(boilerplate3, {bulletShape: 'circle', fontSize: 11}, 1);
    pdf.outputBulletedParagraph(boilerplate4, {bulletShape: 'circle', fontSize: 11}, 1);
    pdf.outputBulletedParagraph(boilerplate5, {bulletShape: 'circle', fontSize: 11}, 1);
    pdf.outputBulletedParagraph(boilerplate6, {bulletShape: 'circle', fontSize: 11}, 1);
    pdf.outputLine({fillColor: '#053064', width: .5});

    pdf.stream();
}
